<!--
  - Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div
    class="is-flex lang-indicator"
    :title="$t('Switch language')"
    @click="() => switchLanguage(getNextLangCode())"
  >
    <span class="is-uppercase">{{ getNextLangCode() }}</span>
  </div>
</template>
<script>
export default {
  methods: {
    getNextLangCode() {
      if (this.$i18n.locale === "en") {
        return "cs";
      }
      return "en";
    },
    switchLanguage(code) {
      this.$i18n.locale = code;
      this.langPopupOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.lang-indicator {
  font-size: 1.5rem;
  line-height: 1.4rem;
  cursor: pointer;
  align-items: center;

  span {
    margin-left: 0.4rem;
  }
}
</style>
